// config.js
const config = {
	baseURL: '',
	projectURL: '',
	ready: false,
};

const initPromise = (async function detectBaseURL() {
	try {

		const data1 = {
			unit: 'cc'
		};

		const res = await fetch('http://[240e:982:c200:8a7b::a6d:316]:9001/api/Sys/LoginSelect', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data1)
		});

		if (res.ok) {
			config.baseURL = 'http://[240e:982:c200:8a7b::a6d:316]:9001/';
			config.projectURL = 'http://[240e:982:c200:8a7b::a6d:316]:9002/';
		} else {
			config.baseURL = 'http://203.56.198.34:9001/';
			config.projectURL = 'http://203.56.198.34:9002/';
		}
	} catch (e) {
		config.baseURL = 'http://203.56.198.34:9001/';
		config.projectURL = 'http://203.56.198.34:9002/';
	} finally {
		config.ready = true;
	}
})();

config.init = () => initPromise;

export default config;